import { BASIC_URL } from 'config/api-variables';
import axios from 'axios';
import { getAuthKey } from 'utils/local-storage/user';

export const uploadFileRequest = (
  file,
  owner_type,
  owner_id,
  context_type,
  context_id,
  currentFolderId,
  sub_context_type,
  sub_context_id,
  onProgress,
  uploadUrl = BASIC_URL + '/file/upload/',
) => {
  const formData = new FormData();
  formData.append('attachment', file);
  formData.append('owner_type', owner_type);
  formData.append('owner_id', owner_id);
  currentFolderId && formData.append('id', currentFolderId);
  context_id && formData.append('context_id', context_id);
  context_type && formData.append('context_type', context_type);
  sub_context_type && formData.append('sub_context_type', sub_context_type);
  sub_context_id && formData.append('sub_context_id', sub_context_id);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Token ${getAuthKey()}`,
    },
    transformRequest: formData => formData,
    onUploadProgress: event => {
      onProgress && onProgress({ percent: (event.loaded / event.total) * 100 });
    },
  };

  return axios.post(uploadUrl, formData, config);
};
